"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressOf = exports.createChecksum = exports.createObjectHash = exports.sortByKeys = void 0;
var _ = require("lodash");
var CryptoJS = require("crypto-js");
var sortByKeys = function (object) {
    var keys = Object.keys(object);
    var sorted = _.sortBy(keys);
    return _.fromPairs(_.map(sorted, function (key) {
        var value = object[key];
        if (typeof object[key] === 'object' && !(object[key] instanceof Array)) {
            value = (0, exports.sortByKeys)(value);
        }
        return [key, value];
    }));
};
exports.sortByKeys = sortByKeys;
var createObjectHash = function (object) {
    return CryptoJS.MD5(Object.values((0, exports.sortByKeys)(object)).join('|')).toString();
};
exports.createObjectHash = createObjectHash;
var createChecksum = function (events, options) {
    if (!options) {
        return null;
    }
    var checksum_secret = '';
    var event_hashes = events.map(function (e) { return e.hash; }).filter(function (h) { return !!h; });
    var checksum_hash = CryptoJS.MD5(event_hashes.join('|'));
    if (!options.address) {
        checksum_secret = CryptoJS.MD5(options.visitor_id + '|' + options.salt).toString();
    }
    else {
        checksum_secret = CryptoJS.MD5(options.visitor_id + '|' + options.address + '|' + options.salt).toString(); // prettier-ignore
    }
    return CryptoJS.AES.encrypt(checksum_hash, checksum_secret).toString();
};
exports.createChecksum = createChecksum;
var addressOf = function (user) {
    return user && !_.isNil(user.address) && !_.isEmpty(user.address) ? user.address : null;
};
exports.addressOf = addressOf;
